module.exports = __webpack_public_path__ + "img/9788954431194.691d475a.jpg";